import React, { useState } from 'react'
import { Trans } from '@lingui/macro'
import {
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { OfflineNavIcon } from './offline-nav-icon'

/**
 * Menu compatto nella top bar mobile. Export per tutti; import ZIP se passato.
 */
export function OfflinePwaMobileMenu({
  isOnline,
  onExport,
  onImportZip,
  onPrepareDevice,
  importZipBusy = false,
  iconButtonSize = 'large',
}) {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const close = () => setAnchorEl(null)
  const run = (fn) => () => {
    close()
    fn()
  }

  return (
    <>
      <IconButton
        size={iconButtonSize}
        aria-label="offline pwa tools"
        onClick={e => setAnchorEl(e.currentTarget)}
        sx={{ color: 'white', flexShrink: 0 }}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={close}>
        <MenuItem disabled dense>
          <Typography variant="caption" color="text.secondary">
            <Trans>Offline operations</Trans>
            {!isOnline ? ` · ` : ''}
            {!isOnline ? <Trans>Offline</Trans> : null}
          </Typography>
        </MenuItem>
        {typeof onPrepareDevice === 'function' && (
          <MenuItem disabled={!isOnline} onClick={run(onPrepareDevice)}>
            <ListItemIcon sx={{ minWidth: 36 }}>
              <OfflineNavIcon variant="prepare" />
            </ListItemIcon>
            <Trans>Prepare device offline</Trans>
          </MenuItem>
        )}
        {typeof onExport === 'function' && (
        <MenuItem onClick={run(onExport)}>
          <ListItemIcon sx={{ minWidth: 36 }}>
            <OfflineNavIcon variant="export" />
          </ListItemIcon>
          <Trans>Export local crashes</Trans>
        </MenuItem>
        )}
        {typeof onImportZip === 'function' && (
          <MenuItem disabled={!isOnline || importZipBusy} onClick={run(onImportZip)}>
            <ListItemIcon sx={{ minWidth: 36 }}>
              <OfflineNavIcon variant="import" />
            </ListItemIcon>
            <Trans>Import crash ZIP</Trans>
          </MenuItem>
        )}
      </Menu>
    </>
  )
}
